import { render, staticRenderFns } from "./food-check.vue?vue&type=template&id=80bafab0&"
import script from "./food-check.vue?vue&type=script&lang=js&"
export * from "./food-check.vue?vue&type=script&lang=js&"
import style0 from "./food-check.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports